import { Route } from '@angular/router';
import { buildDetailDrawerRoute, DetailDrawerTypes } from '@lexplus-shared-lib';
import { UserDetailDrawerTypeKey } from '../models/user-detail-drawer-type-key.model';
import {
  buildAnforderungDetailDrawerType,
  buildArchivierteAnforderungDetailDrawerType,
} from '../../features/compliance-uebersicht/functions/build-anforderung-detail-drawer-type.function';
import { buildAufgabeDetailDrawerType } from '../../features/aufgaben/functions/build-aufgabe-detail-drawer-type.function';
import { buildDokumentDetailDrawerType } from '../../features/dokumenten-manager/functions/build-dokument-detail-drawer-type.function';
import { buildErlassDetailDrawerType } from '../../features/compliance-uebersicht/functions/build-erlass-detail-drawer-type.function';
import { buildIndividuelleAnforderungDetailDrawerType } from '../../features/compliance-uebersicht/functions/build-individuelle-anforderung-detail-drawer-type.function';

/**
 * A detail drawer's route, for a host page of the user app to mount under its own outlet.
 *
 * The host stays mounted behind it, so closing returns there. An item another one contains opens a
 * level below it; one it only links to replaces the path. Each stands behind its own kind's guards.
 *
 * @param {UserDetailDrawerTypeKey} rootType - The kind of item the drawer opens on
 * @param {string} segment - The localized segment the drawer stands on under this host
 * @param {string} routeId - The host's route id, so the sidebar keeps naming the host rather
 *   than the item's own feature
 * @param {string} locale - The base language, which localizes the segments of the other kinds and levels
 * @param {readonly UserDetailDrawerTypeKey[]} opens - Further kinds the host links to, each a first level of its own
 * @returns {Route} The drawer's route
 */
export function UserDetailDrawerRoute(
  rootType: UserDetailDrawerTypeKey,
  segment: string,
  routeId: string,
  locale: string,
  opens: readonly UserDetailDrawerTypeKey[] = [],
): Route {
  return buildDetailDrawerRoute({ segment, routeId, rootType, opens, types: buildUserDetailDrawerTypes(locale) });
}

/**
 * @param {string} locale - The base language
 * @returns {DetailDrawerTypes<UserDetailDrawerTypeKey>} Every kind the user app's drawers show
 */
function buildUserDetailDrawerTypes(locale: string): DetailDrawerTypes<UserDetailDrawerTypeKey> {
  return {
    anforderung: buildAnforderungDetailDrawerType(locale),
    archivierteAnforderung: buildArchivierteAnforderungDetailDrawerType(locale),
    aufgabe: buildAufgabeDetailDrawerType(locale),
    dokument: buildDokumentDetailDrawerType(locale),
    erlass: buildErlassDetailDrawerType(locale),
    individuelleAnforderung: buildIndividuelleAnforderungDetailDrawerType(locale),
  };
}
